import { PARISH } from "./static-data";
import React from 'react';
import { Icon, Tooltip } from "antd";

export const dmsToDecimalDegrees = (dms) => {
  let explodeDms = dms.replace("\"", "");
  explodeDms = explodeDms.replace("°", "|");
  explodeDms = explodeDms.replace("'", "|");
  const dmsArray = explodeDms.split("|");
  const decimalDegrees = (Number.parseInt(dmsArray[0]) + (Number.parseInt(dmsArray[1]) / 60) + (Number.parseInt(dmsArray[2]) / 3600));
  return decimalDegrees.toFixed(3);
}

export const getDayOfWeek = (day) => {
  let dayString = '';
  switch (day) {
    case 1:
      dayString = 'LUNES';
      break;
    case 2:
      dayString = 'MARTES';
      break;
    case 3:
      dayString = 'MIERCOLES';
      break;
    case 4:
      dayString = 'JUEVES';
      break;
    case 5:
      dayString = 'VIERNES';
      break;
    case 6:
      dayString = 'SABADO';
      break;
    case 7:
      dayString = 'DOMINGO';
      break;
    default:
      dayString = '';
      break;
  }
  return dayString;
}

export const getCurrentUser = () => {
  const user = localStorage.getItem('user');
  if (!user) {
    return {};
  }
  return JSON.parse(user);
}

export const roles = () => {
  return [
    { key: 1, name: "Usuario" },
    { key: 4, name: "Ejecutivo" },
    { key: 3, name: "Gobernador" },
    { key: 2, name: "Administrador" }
  ]
}

export const getRole = (role) => {
  let roleName = "Usuario";
  switch (role) {
    case 1:
      roleName = "Usuario";
      break;
    case 2:
      roleName = "Administrador";
      break;
    default:
      roleName = "Usuario";
      break;
  }
  return roleName;
}

export const getChildren = (parent = 0) => {
  const children = JSON.parse(localStorage.getItem('children') || "[]");
  if (parent > 0) {
    return children.filter(child => child.parent_id === parent);
  } else {
    return children;
  }
}

export const getAuthHeader = () => {
  const token = localStorage.getItem('token') || null
  if (token) {
    return { 'Authorization': `Bearer ${token.replace(/"/g, "")}` };
  }
}

export const getAllParents = () => {
  const parents = JSON.parse(localStorage.getItem('parents') || "[]");
  return parents;
}

export const getExecutive = (executive) => {
  const parents = JSON.parse(localStorage.getItem('parents') || "[]");
  const finded = parents.filter(ex => executive === ex.id);

  return finded.length > 0 ? finded[0] : "-";
}

export const getChild = (child) => {
  const children = JSON.parse(localStorage.getItem('children') || "[]");
  const finded = children.filter(ex => child === ex.id);

  return finded.length > 0 ? finded[0] : "-";
}

export const getHttpErrorCodeMessage = (code) => {
  let message = '';
  switch (code) {
    case 401:
      message = 'No esta autorizado para realizar esta acción';
      break;
    case 404:
      message = 'El recurso que busca no fue encontrado';
      break;
    case 400:
      message = 'Ha ocurrido un error con los datos suministrados';
      break;
    default:
      message = 'Ha ocurrido un error.';
      break;
  }
  return message;
}

export const blobToUrlImage = (blob) => {
  return window.URL.createObjectURL(blob);
}

export const getParishCoordinates = (parish) => {
  const findParish = PARISH.find(p => p.id === parish);
  return findParish;
}

export const dateToUnix = (dateRange) => {
  return dateRange.map(week => (
    { start: new Date(week.start).getTime(), end: new Date(week.end).getTime() }
  ));
}

export const getStatusIcon = (status) => {
  let iconConfig = { color: '', type: '' };

  switch (status) {
    case 1:
      iconConfig.color = "#1890ff";
      iconConfig.type = "clock-circle";
      iconConfig.toolTipText = "A realizarse";
      break;
    case 2:
      iconConfig.color = "#52c41a";
      iconConfig.type = "check-circle";
      iconConfig.toolTipText = "Finalizado";
      break;
    case 3:
      iconConfig.color = "#f70707";
      iconConfig.type = "close-circle";
      iconConfig.toolTipText = "No realizada";
      break;
    default:
      iconConfig.color = "#52c41a";
      iconConfig.type = "check-circle";
      iconConfig.toolTipText = "A realizarse";
      break;
  }
  return (
    <Tooltip title={iconConfig.toolTipText}>
      <Icon type={iconConfig.type} theme="twoTone" twoToneColor={iconConfig.color} />
    </Tooltip>
  );
}

export const modalConfig = () => {
  if (isPhone()) {
    return { position: 'fixed', top: 0, width: '100vw', height: '100vh' };
  } else {
    return { width: '80vw' };
  }
}

export const isPhone = () => {
  return (window.innerWidth < 768);
}